var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110.583 57.9167C110.583 63.7617 105.845 68.5 100 68.5C94.1551 68.5 89.4167 63.7617 89.4167 57.9167C89.4167 52.0717 94.1551 47.3333 100 47.3333C105.845 47.3333 110.583 52.0717 110.583 57.9167Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M120.464 89.8472H79.5356C79.7272 81.0526 88.5635 73.5139 100 73.5139C111.436 73.5139 120.273 81.0526 120.464 89.8472Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.5834 57.9167C51.5834 63.7617 46.8451 68.5 41.0001 68.5C35.1551 68.5 30.4167 63.7617 30.4167 57.9167C30.4167 52.0717 35.1551 47.3333 41.0001 47.3333C46.8451 47.3333 51.5834 52.0717 51.5834 57.9167Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.4643 89.8472H20.5356C20.7272 81.0526 29.5635 73.5139 41 73.5139C52.4364 73.5139 61.2727 81.0526 61.4643 89.8472Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M84.5 55C84.5 62.4558 78.4558 68.5 71 68.5C63.5442 68.5 57.5 62.4558 57.5 55C57.5 47.5442 63.5442 41.5 71 41.5C78.4558 41.5 84.5 47.5442 84.5 55Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.2297 95C45.2297 83.6661 56.5145 74 70.9997 74C85.4849 74 96.7697 83.6661 96.7697 95H45.2297Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberEmpty);
export default __webpack_public_path__ + "static/media/memberEmpty.73c54c61b5d519705af8dd1afdc998bc.svg";
export { ForwardRef as ReactComponent };